import { render, staticRenderFns } from "./Home.stags.vue?vue&type=template&id=4ebfb6a4&scoped=true&lang=html&"
import script from "./Home.stags.vue?vue&type=script&lang=js&"
export * from "./Home.stags.vue?vue&type=script&lang=js&"
import style0 from "./Home.stags.vue?vue&type=style&index=0&id=4ebfb6a4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebfb6a4",
  null
  
)

export default component.exports